const LogoWithDesc = ({ logo, title, desc }) => {
  return (
    <div className="px-5 pt-5 mt-5">
      <img width="80" src={logo} alt={title} />
      <h3 className="mt-3 text-light">{title}</h3>
      <div className="mt-3 pr-5 text-light">{desc}</div>
    </div>
  );
};

export default LogoWithDesc;
